import styled from 'styled-components';
import * as colors from '../../colors';
export const Button = styled.button `
  cursor: pointer;
  border: none;
  color: white;
  height: 40px;
  margin: 0;
  padding: 0px 12px;
  font-size: 14px;
  border-radius: 4px;
  // box-shadow: 2px 2px 0px rgba(0,0,0,.1);
  box-shadow: 0px 6px 0px hsl(358, 0%, 92%);
  font-family: ArialRounded;

  &:hover {
    // opacity: 0.8;
  }
`;
export const ButtonSmall = styled(Button) `
  font-size: 16px;
  padding: 2px 12px;
  height: 28px;
  &:active {
    transform: translateY(2px);
    box-shadow: none;
  }
`;
export const ButtonBig = styled(Button) `
  font-size: 22px;
  width: 320px;
  height: 55px;
  &:active {
    transform: translateY(6px);
    box-shadow: none;
  }
`;
const ButtonDefault = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  &:active {
    transform: translateY(2px);
    box-shadow: none;
  }
  color: white;
  opacity: 0.9;
  &:hover {
    opacity: 1;
  }
`;
export const ButtonPrimary = styled(ButtonDefault) `
  // background-color: ${colors.THEME_COLOR};
  font-size: 14px;
  padding: 8px 12px;
  min-width: 70px;
  background-color: #222;
  border: 2px solid #222;
  ${(props) => props.disabled &&
    `
      background-color: #aaa;
      border: 2px solid #aaa;
      pointer-events: none;
      opacity:0.6;
    `}
`;
export const ButtonGreen = styled(ButtonDefault) `
  background-color: #379580;
  border: 2px solid #379580;
  /* border: none; */
  font-size: 14px;
  padding: 8px 16px;
  min-width: 70px;
  flex-shrink: none;
`;
export const ButtonSecondary = styled(ButtonDefault) `
  background-color: hsl(2, 80%, 70%);
  border: none;
  font-size: 14px;
  padding: 8px 16px;
  min-width: 70px;
  background: none;
  border: 2px solid rgba(255, 255, 255, 0.8);
`;
export const ButtonBlue = styled(ButtonDefault) `
  font-size: 14px;
  padding: 8px 12px;
  min-width: 70px;
  background-color: hsl(203, 89%, 53%);
  border: none;
`;
export const ButtonPurple = styled(ButtonDefault) `
  font-size: 14px;
  padding: 8px 12px;
  min-width: 70px;
  background-color: hsl(153, 60%, 53%);
  border: none;
`;
export const ButtonGray = styled(ButtonDefault) `
  font-size: 14px;
  padding: 8px 12px;
  min-width: 70px;
  background-color: #cacaca;
  border: none;
  color: #5b5b5b;
`;
export const ButtonGray2 = styled(ButtonDefault) `
  font-size: 14px;
  padding: 8px 12px;
  min-width: 70px;
  background-color: #dfdfdf;
  border: none;
  box-shadow: none;
  color: #444;
`;
export const ButtonWhite = styled(ButtonDefault) `
  font-size: 14px;
  padding: 8px 12px;
  min-width: 70px;
  background-color: white;
  border: none;
  color: #777;
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid #dcdcdc;
`;
export const ButtonWhiteNoShadow = styled(ButtonDefault) `
  font-size: 14px;
  padding: 8px 12px;
  min-width: 70px;
  background-color: white;
  border: none;
  color: #555;
  font-weight: 600;
  /* letter-spacing: 0.02em; */
  border: 1px solid #e0e0e0;
  box-shadow: none;
  font-weight: normal;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
`;
export const ButtonBorder = styled(ButtonDefault) `
  font-size: 14px;
  padding: 8px 12px;
  min-width: 70px;

  background: none;
  border: 2px solid rgba(0, 0, 0, 0.4);
  box-shadow: none;
  color: rgba(0, 0, 0, 0.4);
  font-weight: bold;
  letter-spacing: 0.02em;
`;
export const ButtonText = styled(ButtonDefault) `
  font-size: 14px;
  background: none;
  border: none;
  box-shadow: none;
  color: rgba(0, 0, 0, 0.4);
  font-weight: bold;
  letter-spacing: 0.02em;
  text-decoration: underline;
  /* text-transform: uppercase; */
`;
// big
export const ButtonWhiteBig = styled(ButtonDefault) `
  font-size: 14px;
  padding: 12px 12px;
  min-width: 70px;
  background-color: white;
  border: none;
  color: #777;
  font-weight: bold;
  letter-spacing: 0.02em;
  width: 100%;
  border: 1px solid #dcdcdc;
`;
export const ButtonPrimaryBig = styled(ButtonDefault) `
  // background-color: ${colors.THEME_COLOR};
  font-size: 14px;
  padding: 12px 12px;
  min-width: 70px;
  background-color: #222;
  border: 2px solid #222;
  width: 100%;
  ${(props) => props.disabled &&
    `
      background-color: #aaa;
      border: 2px solid #aaa;
      pointer-events: none;
    `}
`;
